import { Dropdown as DropdownA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import styles from './dropdown.module.css';
import { PositionAtClickDropdown } from './position-at-click-dropdown';
import { resolveClassNames } from './resolve-class-names';

export type DropdownProperties = {
  positionAtClick?: boolean;
} & ComponentProps<typeof DropdownA>;

const Dropdown = ({ children, classNames, menu, placement, positionAtClick = false, ...rest }: DropdownProperties) => {
  const sharedProperties = {
    classNames: resolveClassNames(classNames, styles.root, styles['menu-item-icon']),
    menu: menu
      ? {
          ...menu,
          className: cn(styles.menu, menu.className),
        }
      : undefined,
    ...rest,
  };

  if (positionAtClick) {
    return <PositionAtClickDropdown {...sharedProperties}>{children}</PositionAtClickDropdown>;
  }

  return (
    <DropdownA {...sharedProperties} placement={placement}>
      {children}
    </DropdownA>
  );
};

export default Dropdown;
